import {
  parseAsArrayOf,
  parseAsInteger,
  useQueryState,
} from '@/utils/useQueryState';

import { RANGE_MAX_VALUE, RANGE_MIN_VALUE } from './RangeFilterComponent';

export const useRangeQueryState = (
  rangeSpan?: Array<number>,
  queryKey: string = 'range'
) => {
  return useQueryState<Array<number>>(
    queryKey,
    parseAsArrayOf(parseAsInteger)
      .withDefault(rangeSpan ?? [RANGE_MIN_VALUE, RANGE_MAX_VALUE])
      .withOptions({ clearOnDefault: true })
  );
};
